import { Component, OnInit, OnChanges } from '@angular/core';
import { AuthenticationService } from '@app/core/business/user/authentication.service';
import { User } from '@app/core/business/user/user';
import { PriceListType } from '@app/core/business/price-list-type.enum';
import { UserService } from '@app/core/business/user/user.service';
import { ContextService } from '@app/core/service/context.service';

@Component({
  selector: 'app-price-list-type-selector',
  templateUrl: './price-list-type-selector.component.html',
  styleUrls: ['./price-list-type-selector.component.scss']
})
/** CLA le 12/02/2019 - T8323 - affichage des prix brut/net */
export class PriceListTypeSelectorComponent implements OnInit,OnChanges {

  activePriceListType=PriceListType.Net;
  public priceListType=PriceListType;

  constructor(
    private contextService: ContextService, 
  ) { }
  
  ngOnInit() {
    this.loadPriceListType();
  }

  ngOnChanges() {
    this.loadPriceListType();
  }
  
  /**
   * Set price list type to use in the different views by default
   */
  public priceListTypeEmitted(priceListType: PriceListType): void {
    // Définition de la nouvelle propriété
    this.contextService.setSelectedPriceList(priceListType);

    // Changement de l'affichage
    this.activePriceListType = this.contextService.context.activePriceListType;

    // rechargement de la page
    location.reload();
  }

  
  /** A remonter dans le contexte si possible pour des raisons de performances */
  private loadPriceListType() {
    this.activePriceListType = this.contextService.context.activePriceListType;
  }
}
